import api from '@services'
import { stripEmptyObjects } from '@utils'

const serviceBaseUrl = process.env.REACT_APP_VEHICLE_BASE_URL ?? ''
const servicePrefix = `${serviceBaseUrl}/svc/vehicle/api`

const getAllVehicleNumberBookings = async (params) => {
  try {
    const response = await api.get(`${servicePrefix}/vehicle-number-bookings`, { params: stripEmptyObjects(params) })
    return response.data
  } catch (err) {
    console.log(err)
    return { data: [], meta: { pageCount: 1, itemCount: 0 } }
  }
}

const checkNumberAvailability = async (data) => {
  const response = await api.post(`${servicePrefix}/vehicle-number-bookings/check-availability`, data)
  return response.data
}

const bookVehicleNumber = async (registration) => {
  const response = await api.post(`${servicePrefix}/vehicle-number-bookings`, registration)
  return response.data
}

const getVehicleNumberBookingById = async (id) => {
  const response = await api.get(`${servicePrefix}/vehicle-number-bookings/${id}`)
  return response.data
}

const updateVehicleNumberBooking = async (booking) => {
  const { id } = booking
  const response = await api.patch(`${servicePrefix}/vehicle-number-bookings/${id}`, booking)
  return response.data
}

const deleteVehicleNumberBooking = async (id) => {
  const response = await api.delete(`${servicePrefix}/vehicle-number-bookings/${id}`)
  return response.data
}

const updatePayment = async (feeId, paymentData) => {
  const response = await api.patch(`${servicePrefix}/vehicle-number-booking-fees/${feeId}/edit-payment`, paymentData)
  return response.data
}

// Texts the owner the client-portal pay link; one SMS per payment advice.
const sendPaymentLink = async (id) => {
  const response = await api.post(`${servicePrefix}/vehicle-number-bookings/${id}/send-payment-link`)
  return response.data
}

const getUnassignedBookingByOwnerAndVehicleType = async (ownerId, vehicleTypeId) => {
  try {
    const response = await api.get(`${servicePrefix}/vehicle-number-bookings/unassigned`, {
      params: { ownerId, vehicleTypeId }
    })
    return response.data
  } catch (err) {
    console.log(err)
    return []
  }
}

const VehicleNumberBookingService = {
  getAllVehicleNumberBookings,
  getVehicleNumberBookingById,
  checkNumberAvailability,
  bookVehicleNumber,
  updateVehicleNumberBooking,
  deleteVehicleNumberBooking,
  updatePayment,
  sendPaymentLink,
  getUnassignedBookingByOwnerAndVehicleType
}

export default VehicleNumberBookingService
